import React, { useEffect, useState, useRef } from 'react';







import { Link } from 'react-router-dom';







import api from '../../utils/api';







import {







  ShieldCheck,







  UserPlus,







  FileText,







  Clock,







  CalendarCheck2,







  BriefcaseBusiness,







  Menu,







  ClipboardList,







  Tags,







} from 'lucide-react';







import './header.css';







import ImageService from '../images/imageService';















const Header = () => {







  const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem('jwt'));







  const [userRole, setUserRole] = useState(







    localStorage.getItem('role')?.replace('ROLE_', '') || ''







  );















  const isAdminOrManager = ['ADMIN', 'MANAGER'].includes(userRole);















  const canRegisterStaffPatient = ['ADMIN', 'MANAGER', 'FRONTDESK'].includes(







    userRole







  );















  const canViewAllPatients = ['ADMIN', 'MANAGER', 'FRONTDESK', 'DOCTOR'].includes(







    userRole







  );















  const canViewAuthorizationHolds = [







    'ADMIN',







    'MANAGER',







    'FRONTDESK',







    'DOCTOR',







  ].includes(userRole);















  const canViewSuperbills = ['ADMIN', 'MANAGER', 'DOCTOR'].includes(userRole);

  const canAccessClinicalNotes = ['ADMIN', 'MANAGER', 'DOCTOR'].includes(userRole);















  const canCreateSuperbills = ['ADMIN', 'MANAGER'].includes(userRole);















  const canViewCheckIn = ['ADMIN', 'MANAGER', 'FRONTDESK'].includes(userRole);















  const canViewPatientsMenu =







    canViewAllPatients || canRegisterStaffPatient || isAdminOrManager;















  const canViewSuperbillMenu = canViewSuperbills || canViewAuthorizationHolds;















  const [activeDropdown, setActiveDropdown] = useState(null);







  const [menuStructure, setMenuStructure] = useState({});







  const [filteredStructure, setFilteredStructure] = useState({});







  const [hoveredCategory, setHoveredCategory] = useState(null);







  const [isMenuOpen, setIsMenuOpen] = useState(false);















  const originalStructure = useRef({});







  const hoverTimer = useRef(null);















  useEffect(() => {







    const handleUserUpdate = () => {







      setIsLoggedIn(!!localStorage.getItem('jwt'));







      setUserRole(localStorage.getItem('role')?.replace('ROLE_', '') || '');







    };















    window.addEventListener('userUpdated', handleUserUpdate);







    window.addEventListener('storage', handleUserUpdate);















    api







      .get('/content/menuStructure')







      .then((res) => {







        setMenuStructure(res.data || {});







        setFilteredStructure(res.data || {});







        originalStructure.current = res.data || {};







      })







      .catch((err) => console.error('Failed to fetch menu structure', err));















    return () => {







      window.removeEventListener('userUpdated', handleUserUpdate);







      window.removeEventListener('storage', handleUserUpdate);















      if (hoverTimer.current) {







        clearTimeout(hoverTimer.current);







      }







    };







  }, []);















  const handleLogout = () => {







    localStorage.clear();







    setIsLoggedIn(false);







    setUserRole('');







    closeMenu();







    window.location.href = '/login/patient';







  };















  const handleMouseEnter = (menu) => {







    clearTimeout(hoverTimer.current);







    setActiveDropdown(menu);







  };















  const handleMouseLeave = () => {







    hoverTimer.current = setTimeout(() => {







      setActiveDropdown(null);







      setHoveredCategory(null);







    }, 200);







  };















  const closeMenu = () => {







    setIsMenuOpen(false);







    setActiveDropdown(null);







    setHoveredCategory(null);







  };















  const toggleMenu = () => {







    setIsMenuOpen((prev) => {







      if (prev) {







        setActiveDropdown(null);







        setHoveredCategory(null);







      }















      return !prev;







    });







  };















  const logoUrl = ImageService.getImageUrl(







    'header',







    'newuphysicaltherapylogo.png'







  );















  return (







    <>







      <div className="topBar">







        <Link to="/contact" className="topBarLink">







          Call / Email Us







        </Link>







      </div>















      <div className="headerWrapper">







        <header className="headerBar">







          <div className="headerLeft">







            <button







              type="button"







              className="menuToggle floatingToggle"







              onClick={toggleMenu}







              aria-label="Toggle navigation menu"







              aria-expanded={isMenuOpen}







            >







              <Menu size={22} />







            </button>















            <img src={logoUrl} alt="Logo" className="logoImg" />







          </div>















          <div className="siteTitle">







            <h1>NEW U PHYSICAL THERAPY</h1>







            <p>







              <em>Let Your Pain Be Our Concern</em>







            </p>







          </div>







        </header>















        <nav className="navbar" />







      </div>















      {isMenuOpen && (







        <div







          className="sideMenuOverlay"







          onClick={closeMenu}







          aria-hidden="true"







        />







      )}















      <aside







        className={`sideMenu ${isMenuOpen ? 'open' : ''}`}







        onClick={(e) => e.stopPropagation()}







      >







        <div className="sideMenuHeader">







          <img src={logoUrl} alt="Logo" className="sideMenuLogo" />







        </div>















        <ul className="navlinks">







          <li className="navitem">







            <Link to="/" className="navlink" onClick={closeMenu}>







              Home







            </Link>







          </li>















          {isAdminOrManager ? (







            <li







              className="navitem"







              onMouseEnter={() => handleMouseEnter('office')}







              onMouseLeave={handleMouseLeave}







            >







              <span className="navlink">Office</span>















              {activeDropdown === 'office' && (







                <ul className="dropdownMenu fadeIn">







                  <li>







                    <Link to="/office" className="dropdownLink" onClick={closeMenu}>







                      <BriefcaseBusiness size={16} /> Office







                    </Link>







                  </li>















                  <li>







                    <Link







                      to="/register/office"







                      className="dropdownLink"







                      onClick={closeMenu}







                    >







                      <BriefcaseBusiness size={16} /> Register Office







                    </Link>







                  </li>















                  <li>







                    <Link







                      to="/register/schedule"







                      className="dropdownLink"







                      onClick={closeMenu}







                    >







                      <CalendarCheck2 size={16} /> Office Schedule







                    </Link>







                  </li>















                  <li>







                    <Link







                      to="/office-schedule-manager"







                      className="dropdownLink"







                      onClick={closeMenu}







                    >







                      <CalendarCheck2 size={16} /> Manage Office Schedule







                    </Link>







                  </li>







                </ul>







              )}







            </li>







          ) : (







            <li className="navitem">







              <Link to="/office" className="navlink" onClick={closeMenu}>







                Office







              </Link>







            </li>







          )}















          {isAdminOrManager ? (







            <li







              className="navitem"







              onMouseEnter={() => handleMouseEnter('staff')}







              onMouseLeave={handleMouseLeave}







            >







              <span className="navlink">Staff</span>















              {activeDropdown === 'staff' && (







                <ul className="dropdownMenu fadeIn">







                  <li>







                    <Link to="/staff" className="dropdownLink" onClick={closeMenu}>







                      <UserPlus size={16} /> Staff







                    </Link>







                  </li>















                  <li>







                    <Link







                      to="/register/staff"







                      className="dropdownLink"







                      onClick={closeMenu}







                    >







                      <UserPlus size={16} /> Register Staff / Doctor







                    </Link>







                  </li>







                </ul>







              )}







            </li>







          ) : (







            <li className="navitem">







              <Link to="/staff" className="navlink" onClick={closeMenu}>







                Staff







              </Link>







            </li>







          )}















          {isAdminOrManager ? (







            <li







              className="navitem"







              onMouseEnter={() => handleMouseEnter('insurance')}







              onMouseLeave={handleMouseLeave}







            >







              <span className="navlink">Insurance</span>















              {activeDropdown === 'insurance' && (







                <ul className="dropdownMenu fadeIn">







                  <li>







                    <Link







                      to="/insurance"







                      className="dropdownLink"







                      onClick={closeMenu}







                    >







                      <ShieldCheck size={16} /> Insurance







                    </Link>







                  </li>















                  <li>







                    <Link







                      to="/register/insurance"







                      className="dropdownLink"







                      onClick={closeMenu}







                    >







                      <ShieldCheck size={16} /> Register Insurance







                    </Link>







                  </li>







                </ul>







              )}







            </li>







          ) : (







            <li className="navitem">







              <Link to="/insurance" className="navlink" onClick={closeMenu}>







                Insurance







              </Link>







            </li>







          )}















          <li className="navitem">







            <Link to="/appointments" className="navlink" onClick={closeMenu}>







              Appointments







            </Link>







          </li>















          {isAdminOrManager ? (







            <li







              className="navitem"







              onMouseEnter={() => handleMouseEnter('rewards')}







              onMouseLeave={handleMouseLeave}







            >







              <span className="navlink">Rewards</span>















              {activeDropdown === 'rewards' && (







                <ul className="dropdownMenu fadeIn">







                  <li>







                    <Link







                      to="/pointpatientinventory"







                      className="dropdownLink"







                      onClick={closeMenu}







                    >







                      <BriefcaseBusiness size={16} /> Rewards







                    </Link>







                  </li>















                  <li>







                    <Link







                      to="/register/point-item"







                      className="dropdownLink"







                      onClick={closeMenu}







                    >







                      <BriefcaseBusiness size={16} /> Point Inventory







                    </Link>







                  </li>















                  <li>







                    <Link







                      to="/points/create-missing"







                      className="dropdownLink"







                      onClick={closeMenu}







                    >







                      <BriefcaseBusiness size={16} /> Missing Points Bank







                    </Link>







                  </li>







                </ul>







              )}







            </li>







          ) : (







            <li className="navitem">







              <Link







                to="/pointpatientinventory"







                className="navlink"







                onClick={closeMenu}







              >







                Rewards







              </Link>







            </li>







          )}















          {isAdminOrManager && (







            <li







              className="navitem"







              onMouseEnter={() => handleMouseEnter('creator')}







              onMouseLeave={handleMouseLeave}







            >







              <span className="navlink">Creator</span>















              {activeDropdown === 'creator' && (







                <ul className="dropdownMenu fadeIn">







                  <li>







                    <Link







                      to="/register/promotion"







                      className="dropdownLink"







                      onClick={closeMenu}







                    >







                      <FileText size={16} /> Promotion







                    </Link>







                  </li>















                  <li>







                    <Link







                      to="/content-creator"







                      className="dropdownLink"







                      onClick={closeMenu}







                    >







                      <FileText size={16} /> Content







                    </Link>







                  </li>







                </ul>







              )}







            </li>







          )}















          {Object.entries(filteredStructure)







            .filter(([extra, categories]) => {







              if (!extra || !extra.trim()) return false;















              const categoryKeys = Object.keys(categories || {});







              return categoryKeys.length > 0;







            })







            .map(([extra, categories]) => {







              const categoryKeys = Object.keys(categories || {});















              return (







                <li







                  key={extra}







                  className="navitem"







                  onMouseEnter={() => handleMouseEnter(extra)}







                  onMouseLeave={() => {







                    handleMouseLeave();







                    setHoveredCategory(null);







                  }}







                >







                  <span className="navlink capitalize">{extra}</span>















                  {activeDropdown === extra && (







                    <div className="dropdownMega twoPanel fadeIn">







                      <div className="dropdownLeft">







                        {categoryKeys.map((cat) => (







                          <div







                            key={cat}







                            className={`dropdownCategory ${







                              hoveredCategory === cat ? 'active' : ''







                            }`}







                            onMouseEnter={() => setHoveredCategory(cat)}







                          >







                            {cat}







                          </div>







                        ))}







                      </div>















                      <div className="dropdownRight">







                        {hoveredCategory ? (







                          (categories[hoveredCategory] || []).map(({ id, title }) => (







                            <Link







                              key={id}







                              to={`/content/${id}`}







                              className="dropdownLink"







                              onClick={closeMenu}







                            >







                              {title}







                            </Link>







                          ))







                        ) : (







                          <div className="dropdownEmpty">







                            Hover over a category







                          </div>







                        )}







                      </div>







                    </div>







                  )}







                </li>







              );







            })}















          {isLoggedIn ? (







            <>







              {canViewPatientsMenu && (







                <li







                  className="navitem"







                  onMouseEnter={() => handleMouseEnter('patients')}







                  onMouseLeave={handleMouseLeave}







                >







                  <span className="navlink">Patients</span>















                  {activeDropdown === 'patients' && (







                    <ul className="dropdownMenu fadeIn">







                      {canViewAllPatients && (







                        <li>







                          <Link







                            to="/allpatients"







                            className="dropdownLink"







                            onClick={closeMenu}







                          >







                            <UserPlus size={16} /> All Patients







                          </Link>







                        </li>







                      )}















                      {canRegisterStaffPatient && (







                        <li>







                          <Link







                            to="/register/staff-patient"







                            className="dropdownLink"







                            onClick={closeMenu}







                          >







                            <UserPlus size={16} /> Staff Patient Registration







                          </Link>







                        </li>







                      )}















                      {isAdminOrManager && (







                        <>







                          <li>







                            <Link







                              to="/register/insurance-patient"







                              className="dropdownLink"







                              onClick={closeMenu}







                            >







                              <ShieldCheck size={16} /> Register Patient Insurance







                            </Link>







                          </li>















                          <li>







                            <Link







                              to="/register/authorization"







                              className="dropdownLink"







                              onClick={closeMenu}







                            >







                              <FileText size={16} /> Register Patient Authorization







                            </Link>







                          </li>







                        </>







                      )}







                    </ul>







                  )}







                </li>







              )}















              {isAdminOrManager && (







                <li







                  className="navitem"







                  onMouseEnter={() => handleMouseEnter('clinicalSetup')}







                  onMouseLeave={handleMouseLeave}







                >







                  <span className="navlink">Clinical Setup</span>















                  {activeDropdown === 'clinicalSetup' && (







                    <ul className="dropdownMenu fadeIn">







                      <li>







                        <Link







                          to="/register/procedure-diagnosis"







                          className="dropdownLink"







                          onClick={closeMenu}







                        >







                          <Clock size={16} /> Add Procedure / Diagnosis







                        </Link>







                      </li>















                      <li>







                        <Link







                          to="/procedure-diagnosis-manager"







                          className="dropdownLink"







                          onClick={closeMenu}







                        >







                          <ClipboardList size={16} /> Manage Procedure / Diagnosis







                        </Link>







                      </li>















                      <li>







                        <Link







                          to="/authorization-hold-flags"







                          className="dropdownLink"







                          onClick={closeMenu}







                        >







                          <Tags size={16} /> Authorization Hold Flags







                        </Link>







                      </li>







                      {isAdminOrManager && (



                        <>



                          <li>



                            <Link



                              to="/clinical-template-setup"



                              className="dropdownLink"



                              onClick={closeMenu}



                            >



                              <ClipboardList size={16} /> Clinical Note Template Setup



                            </Link>



                          </li>







                          <li>



                            <Link



                              to="/clinical-template-setup?section=body-parts"



                              className="dropdownLink"



                              onClick={closeMenu}



                            >



                              <FileText size={16} /> Body Part Templates



                            </Link>



                          </li>







                          <li>



                            <Link



                              to="/clinical-template-setup?section=pain"



                              className="dropdownLink"



                              onClick={closeMenu}



                            >



                              <FileText size={16} /> Pain Templates



                            </Link>



                          </li>







                          <li>



                            <Link



                              to="/clinical-template-setup?section=rom"



                              className="dropdownLink"



                              onClick={closeMenu}



                            >



                              <FileText size={16} /> ROM Templates



                            </Link>



                          </li>







                          <li>



                            <Link



                              to="/clinical-template-setup?section=strength"



                              className="dropdownLink"



                              onClick={closeMenu}



                            >



                              <FileText size={16} /> Strength Templates



                            </Link>



                          </li>







                          <li>



                            <Link



                              to="/clinical-template-setup?section=goals"



                              className="dropdownLink"



                              onClick={closeMenu}



                            >



                              <FileText size={16} /> Goal Templates



                            </Link>



                          </li>







                          <li>



                            <Link



                              to="/clinical-template-setup?section=special-tests"



                              className="dropdownLink"



                              onClick={closeMenu}



                            >



                              <FileText size={16} /> Special Test Templates



                            </Link>



                          </li>







                          <li>



                            <Link



                              to="/clinical-template-setup?section=palpation"



                              className="dropdownLink"



                              onClick={closeMenu}



                            >



                              <FileText size={16} /> Palpation Templates



                            </Link>



                          </li>







                          <li>



                            <Link



                              to="/clinical-template-setup?section=clinical-content"



                              className="dropdownLink"



                              onClick={closeMenu}



                            >



                              <FileText size={16} /> Clinical Content Templates



                            </Link>



                          </li>







                          <li>



                            <Link



                              to="/clinical-template-setup?section=treatment"



                              className="dropdownLink"



                              onClick={closeMenu}



                            >



                              <FileText size={16} /> Treatment Templates



                            </Link>



                          </li>







                          <li>



                            <Link



                              to="/clinical-template-setup?section=insurance-rules"



                              className="dropdownLink"



                              onClick={closeMenu}



                            >



                              <ShieldCheck size={16} /> Insurance Note Rules



                            </Link>



                          </li>







                          <li>



                            <Link



                              to="/clinical-template-setup?section=provider-signatures"



                              className="dropdownLink"



                              onClick={closeMenu}



                            >



                              <FileText size={16} /> Provider Signatures



                            </Link>



                          </li>



                        </>



                      )}







                    </ul>







                  )}







                </li>







              )}















              {canViewSuperbillMenu && (







                <li







                  className="navitem"







                  onMouseEnter={() => handleMouseEnter('superbill')}







                  onMouseLeave={handleMouseLeave}







                >







                  <span className="navlink">Superbill</span>















                  {activeDropdown === 'superbill' && (







                    <ul className="dropdownMenu fadeIn">







                      {canViewSuperbills && (







                        <li>







                          <Link







                            to="/superbill"







                            className="dropdownLink"







                            onClick={closeMenu}







                          >







                            <FileText size={16} /> View Superbills







                          </Link>







                        </li>







                      )}















                      {canAccessClinicalNotes && (

                        <li>

                          <Link

                            to="/superbill"

                            className="dropdownLink"

                            onClick={closeMenu}

                            title="Open a superbill and choose Clinical Note"

                          >

                            <ClipboardList size={16} /> Clinical Notes

                          </Link>

                        </li>

                      )}



                      {canCreateSuperbills && (







                        <li>







                          <Link







                            to="/superbill/create"







                            className="dropdownLink"







                            onClick={closeMenu}







                          >







                            <FileText size={16} /> Create Superbill







                          </Link>







                        </li>







                      )}















                      {canViewAuthorizationHolds && (







                        <li>







                          <Link







                            to="/authorization-holds"







                            className="dropdownLink"







                            onClick={closeMenu}







                          >







                            <ClipboardList size={16} /> Authorization Holds







                          </Link>







                        </li>







                      )}







                    </ul>







                  )}







                </li>







              )}















              {canViewCheckIn && (







                <li className="navitem">







                  <Link







                    to="/frontdeskcheckin"







                    className="navlink"







                    onClick={closeMenu}







                  >







                    Check-In







                  </Link>







                </li>







              )}















              {isAdminOrManager && (







                <>







                  <li className="navitem">







                    <Link







                      to="/manageclocktimecard"







                      className="navlink"







                      onClick={closeMenu}







                    >







                      Manage Timecards







                    </Link>







                  </li>















                  <li className="navitem">







                    <Link







                      to="/ratingadminview"







                      className="navlink"







                      onClick={closeMenu}







                    >







                      View Ratings







                    </Link>







                  </li>







                </>







              )}















              <li className="navitem">







                <Link







                  to={







                    userRole === 'PATIENT'







                      ? '/dashboard/patient'







                      : '/dashboard/doctor'







                  }







                  className="navlink"







                  onClick={closeMenu}







                >







                  Dashboard







                </Link>







              </li>















              <li className="navitem">







                <span className="navlink" onClick={handleLogout}>







                  Logout







                </span>







              </li>







            </>







          ) : (







            <>







              <li className="navitem">







                <Link







                  to="/register/patient"







                  className="navlink"







                  onClick={closeMenu}







                >







                  Register







                </Link>







              </li>















              <li







                className="navitem"







                onMouseEnter={() => handleMouseEnter('login')}







                onMouseLeave={handleMouseLeave}







              >







                <span className="navlink">Login</span>















                {activeDropdown === 'login' && (







                  <ul className="dropdownMenu fadeIn">







                    <li>







                      <Link







                        to="/login/patient"







                        className="dropdownLink"







                        onClick={closeMenu}







                      >







                        Patient Login







                      </Link>







                    </li>















                    <li>







                      <Link







                        to="/login/doctor"







                        className="dropdownLink"







                        onClick={closeMenu}







                      >







                        Doctor Login







                      </Link>







                    </li>







                  </ul>







                )}







              </li>







            </>







          )}







        </ul>







      </aside>







    </>







  );







};















export default Header;